<p-dialog
    [visible]="visible"
    (visibleChange)="$event ? null : close()"
    (onShow)="load()"
    [modal]="true"
    [closable]="!running"
    [style]="{width: 'min(960px, 95vw)'}"
>
    <ng-template #header>
        <span
            class="fs-6 fw-bold"
            i18n="@@tileImageBackfillTitle"
        >Kachelbilder generieren</span>
    </ng-template>

    <p
        class="text-muted"
        i18n="@@tileImageBackfillIntro"
    >Alle globalen Kacheln ohne Titelbild oder Icon. Die Prompts sind aus Name und Beschreibung vorgeschlagen und
        können angepasst werden. Die Bilder werden nacheinander mit fal.ai erzeugt und direkt an der Kachel gespeichert.</p>

    <div class="backfill-replace">
        <span i18n="@@tileImageBackfillReplace">Vorhandene Bilder neu generieren:</span>
        <label class="backfill-replace-option">
            <p-checkbox
                [(ngModel)]="replace.icon"
                [binary]="true"
                [disabled]="running || loading"
                (onChange)="load()"
            ></p-checkbox>
            <span i18n="@@tileImageBackfillReplaceIcons">Icons</span>
        </label>
        <label class="backfill-replace-option">
            <p-checkbox
                [(ngModel)]="replace.cover"
                [binary]="true"
                [disabled]="running || loading"
                (onChange)="load()"
            ></p-checkbox>
            <span i18n="@@tileImageBackfillReplaceCovers">Titelbilder</span>
        </label>
    </div>
    @if (replace.icon || replace.cover) {
    <p
        class="backfill-warning"
        role="note"
    ><i
            class="ri-alert-line"
            aria-hidden="true"
        ></i> <span i18n="@@tileImageBackfillReplaceWarning">Die vorhandenen Bilder der ausgewählten Kacheln werden
            überschrieben und lassen sich nicht wiederherstellen.</span></p>
    }

    @if (loading) {
    <p i18n="@@tileImageBackfillLoading">Kacheln werden geladen …</p>
    } @else if (error) {
    <p class="text-danger">{{error}}</p>
    } @else if (!rows.length) {
    <p i18n="@@tileImageBackfillNone">Alle Kacheln haben bereits Titelbild und Icon.</p>
    } @else {
    <div class="backfill-list">
        @for (row of rows; track row.tileId) {
        <div
            class="backfill-row"
            [class.is-done]="row.state === 'done'"
        >
            <div class="backfill-head">
                <p-checkbox
                    [(ngModel)]="row.selected"
                    [binary]="true"
                    [disabled]="running || row.state === 'done'"
                    [inputId]="'backfill-' + row.tileId"
                ></p-checkbox>
                <span
                    class="backfill-color"
                    [style.background]="row.color"
                ></span>
                <label
                    class="fw-bold"
                    [for]="'backfill-' + row.tileId"
                >{{row.name}}</label>
                <span class="backfill-state">
                    @switch (row.state) {
                    @case ('running') { <i class="ri-loader-4-line ri-spin"></i> <span i18n="@@tileImageBackfillRunning">wird erstellt …</span> }
                    @case ('done') { <i class="ri-check-line text-success"></i> <span i18n="@@tileImageBackfillDone">gespeichert</span> }
                    @case ('failed') { <i class="ri-error-warning-line text-danger"></i> <span class="text-danger">{{row.message}}</span> }
                    }
                </span>
            </div>
            @for (slot of row.missing; track slot) {
            <label class="backfill-prompt">
                <span>{{slotLabels[slot]}} @if (row.replaces.includes(slot)) { <small
                        class="backfill-replaces"
                        i18n="@@tileImageBackfillReplaces"
                    >– ersetzt das vorhandene Bild</small> }</span>
                <textarea
                    pTextarea
                    rows="2"
                    maxlength="2000"
                    [(ngModel)]="row.prompts[slot]"
                    [disabled]="running || row.state === 'done'"
                ></textarea>
            </label>
            }
        </div>
        }
    </div>
    }

    <ng-template #footer>
        @if (confirming) {
        <span
            class="backfill-confirm me-auto"
            role="alert"
            i18n="@@tileImageBackfillConfirm"
        >{{replacedImages}} vorhandene Bilder werden überschrieben und sind danach weg. Wirklich fortfahren?</span>
        <button
            pButton
            type="button"
            [outlined]="true"
            (click)="confirming = false"
            i18n="@@tileImageBackfillConfirmCancel"
        >Abbrechen</button>
        <button
            pButton
            type="button"
            severity="danger"
            (click)="start()"
        ><i
                class="ri-refresh-line me-1"
                aria-hidden="true"
            ></i><span i18n="@@tileImageBackfillConfirmReplace">Ja, Bilder ersetzen</span></button>
        } @else {
        <small
            class="text-muted me-auto"
            i18n="@@tileImageBackfillCost"
        >{{selectedImages}} Bilder ausgewählt. Generierungen sind kostenpflichtig.</small>
        @if (running) {
        <button
            pButton
            type="button"
            [outlined]="true"
            (click)="stop()"
            i18n="@@tileImageBackfillStop"
        >Nach dieser Kachel anhalten</button>
        } @else {
        <button
            pButton
            type="button"
            [outlined]="true"
            (click)="close()"
            i18n="@@tileImageBackfillClose"
        >Schließen</button>
        }
        <button
            pButton
            type="button"
            [disabled]="running || loading || !selectedImages"
            [loading]="running"
            (click)="requestStart()"
        ><i
                class="ri-sparkling-line me-1"
                aria-hidden="true"
            ></i><span i18n="@@tileImageBackfillStart">Bilder generieren</span></button>
        }
    </ng-template>
</p-dialog>
